export const getCurrentStep = (state) => {
    return state.step
}

export const getStepStatus = (state) => {
    return state.step_status
}

export const getModalStatus = (state) => {
    return state.show_modal
}

export const getNotificationPreference = (state) => {
    return state.notification
}

export const getAudienceId = (state) => {
    return state.audience_id
}

export const getDescription = (state) => {
    return state.description
}

export const getActivation = (state) => {
    return state.activation
}

export const getAudience = (state) => {
    return state.audience
}

export const getActivationAnalyses = (state) => {
    return state.activation_analyses
}

export const getLimitByFrequencyStatus = (state) => {
    return state.limits.freq.status
}

export const getDistanceAnalysesLimit = (state) => {
    return state.limits.distance.range
}

export const getLimitByDistanceStatus = (state) => {
    return state.limits.distance.status
}

export const getRangeMinimum = (state) => (type) => {
    return state.limits[type].min
}

export const getRangeMaximum = (state) => (type) => {
    return state.limits[type].max
}

export const getFrequencyRange = (state) => {
    return state.limits.freq.range
}

export const getLimitsTotal = (state) => {
    return state.limits.total
}

export const getActivationEndpoints = (state) => {
    return state.partners
}

export const getActivationPartner = (state) => {
    return state.partner
}

export const getActivationPartnerInputByIndex = (state) => (index) => {
    return state.partner.inputs[index].name
}

export const getPricingModels = (state) => {
    return state.pricing_models
}

export const getPricingModelsData = (state) => {
    return state.pricing_models_data
}

export const getPricingModel = (state) => {
    return state.pricing_model
}

export const getPrice = (state) => {
    return state.price
}

export const getAudienceCompressionType = (state) => {
    return state.data_delivery.audience.compression
}

export const getAudienceInputByIndex = (state) => (index) => {
    return state.data_delivery.audience[index]
}

export const getAudienceServiceAccount = (state) => {
    return state.data_delivery.audience.service_account
}

export const getAudienceServiceAccountFile = (state) => {
    return state.data_delivery.audience.service_account_file
}

export const getAudienceInputs = (state) => {
    return state.data_delivery.audience.inputs
}

export const getDataStreamInputByIndex = (state) => (payload) => {
    return state.data_delivery.datastreams[payload.data_stream].inputs[payload.index]
}

export const getDataStreamServiceAccount = (state) => (data_stream) => {
    return state.data_delivery.datastreams[data_stream].service_account
}

export const getDataStreamServiceAccountFile = (state) => (data_stream) => {
    return state.data_delivery.datastreams[data_stream].service_account_file
}

export const getDataStreamStatus = (state) => (data_stream) => {
    return state.data_delivery.datastreams[data_stream].status
}

export const getDataStreamVisualizingStatus = (state) => (data_stream) => {
    return state.data_delivery.datastreams[data_stream].visualizing_status
}

export const getDataStreamCompressionType = (state) => (data_stream) => {
    return state.data_delivery.datastreams[data_stream].compression
}

export const getDataStreamCustomDeliveryData = (state) => (index) => {
    return state.data_delivery.datastreams[index].custom_delivery
}

export const getDataStreamsLoadingStatus = (state) => {
    return state.datastreams_loading_completed
}

export const getAudienceDeliveryData = (state) => {
    return state.data_delivery.audience
}

export const getDataStreamsDeliveryData = (state) => {
    return state.data_delivery.datastreams
}

export const getDataStreamsOptions = (state) => {
    return state.datastreams.all
}